// The browser-side twin of requireWorkspaceModuleAccess: which roles may open a
// member-only module (Audit today; Launch keeps its own named commit policy in
// launch-access.ts). The server enforces it; this only shapes navigation and
// sends a viewer to Media Performance before a module loader runs.
import type { Role } from "@aco/core";

export interface ModuleViewer {
  isSuperAdmin: boolean;
  organizations: ReadonlyArray<{ slug: string; role: Role }>;
}

export function canUseWorkspaceModule(viewer: ModuleViewer, orgSlug: string): boolean {
  if (viewer.isSuperAdmin) return true;
  const organization = viewer.organizations.find((org) => org.slug === orgSlug);
  return organization ? organization.role === "admin" || organization.role === "member" : false;
}

export function workspaceModuleRedirect(
  viewer: ModuleViewer,
  orgSlug: string,
): { to: "/$orgSlug/media-performance"; params: { orgSlug: string } } | null {
  if (canUseWorkspaceModule(viewer, orgSlug)) return null;
  return { to: "/$orgSlug/media-performance", params: { orgSlug } };
}
